import { createIntl, createIntlCache, IntlShape } from 'react-intl';

const cache = createIntlCache();

// Define a utility to load the locale data
const loadLocaleData = async (locale: string) => {
  switch (locale) {
    case 'cs':
      return import('../locales/cs.json');
    default:
    case 'de':
      return import('../locales/de.json');
    case 'en':
      return import('../locales/en.json');
    case 'es':
      return import('../locales/es.json');
    case 'fr':
      return import('../locales/fr.json');
    case 'hr':
      return import('../locales/hr.json');
    case 'it':
      return import('../locales/it.json');
    case 'ja':
      return import('../locales/ja.json');
    case 'nl':
      return import('../locales/nl.json');
    case 'pl':
      return import('../locales/pl.json');
    case 'pt':
      return import('../locales/pt.json');
    case 'ro':
      return import('../locales/ro.json');
    case 'ru':
      return import('../locales/ru.json');
    case 'sr':
      return import('../locales/sr.json');
    case 'tr':
      return import('../locales/tr.json');
  }
};

// Custom error handling function to prevent unwanted error logging to console.
export const intlErrorHandler = () => {
  // eslint-disable-next-line no-console
  // console.log();
};

// Define a function to create an intl instance
export const createIntlInstance = async (locale: string): Promise<IntlShape> => {
  const messages = await loadLocaleData(locale);
  return createIntl({ locale, messages: messages.default }, cache);
};
